const { validate, version } = require('uuid');

module.exports = (uuid) => {

    return validate(uuid) && version(uuid) === 4;
};
